/**
 * Schema Zod para el formulario de auto-delegación AFIP (ORR-111).
 *
 * - pin: exactamente 4 dígitos (PIN global del usuario en Menta).
 * - servicios: al menos 1 servicio a delegar.
 * - guardarClave: registra el consentimiento firmado (Letrita A). La clave ya está guardada en
 *   Claves: el bot no recibe otra (ORR-637).
 * - consentimientoUrl: requerido si guardarClave === true.
 */
import { z } from 'zod'

export const SERVICIO_CODIGO = [
  'wsccomu',
  'wsmtxca',
  'sistema_registral',
  'monotributo',
] as const

export const autoDelegarAfipSchema = z
  .object({
    pin: z
      .string()
      .regex(/^\d{4}$/, 'El PIN debe ser de 4 dígitos numéricos'),
    servicios: z
      .array(z.enum(SERVICIO_CODIGO))
      .min(1, 'Seleccioná al menos un servicio'),
    guardarClave: z.boolean(),
    consentimientoUrl: z.string().nullable().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.guardarClave && !data.consentimientoUrl) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['consentimientoUrl'],
        message:
          'Para registrar el consentimiento necesitás la URL del documento firmado',
      })
    }
  })

export type AutoDelegarAfipFormValues = z.infer<typeof autoDelegarAfipSchema>
